import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { format, parseISO } from 'date-fns';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import ButtonsBar from '../../components/buttons-bar/buttons-bar';
import Empty from '../../components/empty/empty';
import ErrorComponent from '../../components/error/error';
import FeatureTitle from '../../components/feature-title/feature-title';
import List from '../../components/list/list';
import Loading from '../../components/loading/loading';
import SubmitButton from '../../components/submit-button/submit-button';

// Models
import {
  BaseContentContainerActionButtonPosition,
  BaseContentContainerFormat,
} from '../../models/base-content-container';

// Helpers
import { classroomsToLabel } from '../../helpers/announcement-helper';

// Services
import AnnouncementService from '../../services/announcement-service';
import SchoolService from '../../services/school-service';
import StorageService from '../../services/storage-service';

const AnnouncementList = () => {
  const titles: ListContentTitle[] = [
    { text: 'Título' },
    { text: 'Turmas' },
    { text: 'Data de envio', align: 'right' },
    { text: 'Visualizados', align: 'right' },
  ];

  const [error, setError] = useState(false);
  const [announcementList, setAnnouncementList] = useState<ListContent[]>(null);

  useEffect(() => {
    const schoolService = new SchoolService();
    const storageService = new StorageService();
    const schoolId = storageService.getEmployee().schoolId;

    schoolService
      .getSchoolById(schoolId)
      .then((school) => {
        const announcementService = new AnnouncementService(school.uuid);

        return announcementService.listAllBackoffice();
      })
      .then((items) => {
        const newAnnouncementList: ListContent[] = items.map((item) => ({
          linkTo: `/comunicados/${item.id}`,
          data: [
            {
              text: item.title,
              customStyle: { maxWidth: '250px' },
            },
            {
              text: classroomsToLabel(item.classrooms),
            },
            {
              text: format(parseISO((item.scheduledAt ?? item.createdAt).local), 'dd/MM/yyyy'),
              subText: item.isScheduled ? 'Agendada' : null,
              align: 'right',
            },
            {
              text: `${item.visualizedRecipients}/${item.totalRecipients}`,
              align: 'right',
            },
          ],
        }));

        setAnnouncementList(newAnnouncementList);
      })
      .catch(() => setError(true));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <ErrorComponent type='contentFull' />;

  if (!announcementList) return <Loading type='contentFull' />;

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.singleWithActionButtons}
      actionButtonPosition={BaseContentContainerActionButtonPosition.top}
    >
      <ButtonsBar pattern='firstSeparate'>
        <FeatureTitle title='comunicados' />
        <Link to='/comunicados/criar'>
          <SubmitButton value='criar novo comunicado' variant='primary' />
        </Link>
      </ButtonsBar>

      {announcementList.length > 0 ? (
        <List titles={titles} contents={announcementList} />
      ) : (
        <Empty />
      )}
    </BaseContentContainer>
  );
};

export default AnnouncementList;
